module.exports = __webpack_public_path__ + "static/img/buddy_mini_profile_800x587.66cda9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_mini_profile_800x587.jpg
// module id = o5hf
// module chunks = 0